module.exports = __webpack_public_path__ + "static/media/backlog.8a7ff625.png";